export default "__VITE_ASSET__67b23d1c__"